import styled from '@emotion/styled';
import { settingsTheme as t } from '../../theme';
import { InstructorType } from '../data/instructors';

interface TypeBadgeProps {
  type: InstructorType;
  label: string;
}

const Badge = styled.span<{ bg: string; color: string }>(({ bg, color }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  padding: '5px 12px',
  borderRadius: 20,
  fontFamily: t.font,
  fontSize: 12.5,
  fontWeight: 600,
  background: bg,
  color,
}));

/**
 * Primitivo: insignia del tipo de instructor (interno o externo).
 */
const TypeBadge = ({ type, label }: TypeBadgeProps) => {
  const external = type === 'external';
  return (
    <Badge
      bg={external ? t.color.typeExternalBg : t.color.typeInternalBg}
      color={external ? t.color.typeExternalText : t.color.typeInternalText}
    >
      {label}
    </Badge>
  );
};

export default TypeBadge;
